module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("buj19"))).then(() => parcelRequire('37nVf'));